import { loadStripe } from '@stripe/stripe-js'

export function stripePublishableKey(environment: {
  VITE_STRIPE_PUBLISHABLE_KEY?: string
  PROD?: boolean
}) {
  if (environment.VITE_STRIPE_PUBLISHABLE_KEY) return environment.VITE_STRIPE_PUBLISHABLE_KEY
  if (environment.PROD) return null

  return 'pk_test_51MockPhonePaymentsHostedFields'
}

const publishableKey = stripePublishableKey(import.meta.env)

export const stripePromise = publishableKey ? loadStripe(publishableKey) : null
